/* eslint-disable @typescript-eslint/no-explicit-any */

import { isDev } from "../chillnn/enviroment";

import type { Payjp } from "./type";

/** site-embed `payjp-window-registry.ts` の `CHILLNN_PAYJP_WINDOW_REGISTRY_KEY` と同一であること */
const CHILLNN_PAYJP_WINDOW_REGISTRY_KEY = "__chillnnPayjpSingletonByPublicKey";

/**
 *
 * @description フォームのplaceholderおよびエラー時のメッセージの言語を指定します。デフォルトはja(日本語)で、他にen(英語)を指定できます。
 *
 */
type Locale = "ja" | "en";

/**
 *
 * @description Payjpのクライアントライブラリを初期化
 *
 * @link {https://pay.jp/docs/payjs}
 *
 */
export const payjpInit = (locale: Locale) => {
	try {
		const publicKey = import.meta.env.VITE_PAYJP_PUBKEY;
		const w = window as unknown as Record<string, Record<string, Payjp.Instance>>;
		const reused = w[CHILLNN_PAYJP_WINDOW_REGISTRY_KEY]?.[publicKey];
		if (reused) {
			return reused;
		}
		const payjp = (window as any).Payjp(publicKey, { locale }) as Payjp.Instance;
		const bucket = (w[CHILLNN_PAYJP_WINDOW_REGISTRY_KEY] ??= {});
		bucket[publicKey] = payjp;
		return payjp;
	} catch (error) {
		if (isDev) {
			// console.error(error);
		}
	}
};

/**
 *
 * @description Payjp のクライアントライブラリを削除
 *
 * @todo Payjp を初期化した後は、unmount 時にこの関数を実行する必要がある
 *
 */
export const payjpDelete = () => {
	if ((window as any).Payjp) {
		delete (window as any).Payjp;
	}
};
